/*--------------------------------------------------------------------------------------------------
	Static
--------------------------------------------------------------------------------------------------*/

if (window.Static == null) Static = {
	base: '',
	thread: {}
}

/*--------------------------------------------------------------------------------------------------
	Threads
--------------------------------------------------------------------------------------------------*/

function thread_Focus() {
	thread_showPost();
	$('#field-post-text').focus();

	$.scrollTo($('#field-post-text'), { duration: 500, offset: { left : 0, top: -200 } });
}

function thread_showPost() {
	if (Static.thread.replying || Static.thread.edit) return false;

	thread_initPost($('#thread-form'));

	return false;
}

function thread_initPost($form) {
	player_deFocus();

	$form.addClass('opened');
	$form.find('textarea').css('height', 150).on('input', function() {
		var l = $(this).val().length, th = 1500, el = $('#post-hint');
		if(l > 500) {
			if(!el.length) {
				$('#thread-form-top').prepend("<span id='post-hint'></span>");
				el = $('#post-hint');
			}
			el.html('Осталось ' + (th - l) + ' символов');
		} else if(el.length) el.remove();
	});
	$form.find('.buttons').show();
	$('#post-images').show();
	atWho_init();
}

function thread_hidePostonBlur() {
	if(Static.thread.sending) return false;
	setTimeout(thread_hidePost, 200);
}

function thread_hidePost() {
	if(Static.thread.replying || Static.thread.edit || !Static.thread.id) return false;

	editor_hideImageUploader(false);

	var $form = $('#thread-form');
	$form.prependTo('#thread-form-top').removeClass('opened');
	$form.find('textarea').css('height', 30).off('input');
	$form.find('.buttons').hide();
	$('#post-images').hide();
	$('#post-hint').remove();

	return false;
}

function thread_Reply(event, post_id) {
	var $form = $('#thread-form'), $ta = $('#field-post-text');

	var uname = $('#post-' + post_id + ' .info').find('a').html().replace(/<span.*?<\/span> /gi, '');
	uname = uname.split(" ").join("\u00A0");

	if(Static.thread.replying != 0) {
		$('#post-' + post_id).after($form);

		if(!Static.thread.tree) {
			var val = $ta.val() + '\n\n@' + uname + ', ';
			$ta.val(val);
			$ta.focus();
			editor_setCursor($ta[0], val.length, val.length);

			event.stopPropagation();
			return false;
		}
	}

	thread_initPost($form);

	$('#post-'+post_id).after($form);
	$form.show();

	Static.thread.replying = post_id;
	Static.thread.edit = 0;

	$ta.focus();
	if(!Static.thread.tree) $('#field-post-text').val('@' + uname + ', ');

	event.stopPropagation();

	return false;
}

function thread_Quote(text, post_id) {
	var $form = $('#thread-form'), $ta = $('#field-post-text');

	var uname = $('#post-' + post_id + ' .info').find('a').html().replace(/<span.*?<\/span> /gi, '');
	uname = uname.split(" ").join("\u00A0");

	if(Static.thread.replying != 0) {
		$('#post-' + post_id).after($form);

		if(!Static.thread.tree) {
			var val = $ta.val() + '\n\n@' + uname + ',\n>' + text.replaceAll('\n', '\n>');
			$ta.val(val);
			$ta.focus();
			editor_setCursor($ta[0], val.length, val.length);

			return false;
		}
	}

	thread_initPost($form);

	$('#post-'+post_id).after($form);
	$form.show();

	Static.thread.replying = post_id;
	Static.thread.edit = 0;

	$ta.focus();
	if (!Static.thread.tree) $('#field-post-text').val('@' + uname + ',\n>' + text.replaceAll('\n', '\n>'));

	return false;
}

function thread_Edit(event, post_id) {
	var $form = $('#thread-form'), $ta = $('#field-post-text');

	$.post(Static.base + '/thread.php?mode=ajax_post_text', {id: post_id}, function(data) {
		$ta.val(data);
	});

	thread_initPost($form);

	$('#post-'+post_id).after($form);
	$form.show();

	Static.thread.edit = post_id;
	Static.thread.replying = 0;

	$ta.focus();

	event.stopPropagation();

	return false;
}

function editor_Preview() {
	var text = $('.field-post-text').val();
	if (text == '') return false;
	text = utf8_to_cp1251(text);

	$('#field-loader').html("<img src='" + Static.base + "/resource/image/icon/ajax.gif'>");

	//$.post(Static.base + '/thread.php?mode=ajax_post_preview', {text: text}, function(data) {
	$.post('https://w.hlamer.ru/get?action=post_preview', {text: text}, function(data) {
		tagsProcess($('#post-preview').html(data).show());
		$('#field-loader').html('');
	});

	return false;
}

function editor_applyImagePromt() {
	editor_applyImage(prompt('Введите адрес картинки'));
}

function editor_applyImage(img) {
	if(!img) return false;

	var fp = /.*?\.(gif|png|jpeg|jpg)/gi.exec(img);
	if(fp == null) return false;

	editor_applyTag("<img src='" + img + "'>", '');
}

function editor_showColors(el) {
	var pos = $(el).offset();
	var $c = $("<div id='editor-colors' style=\"padding: 10px; width: 176px; background: #f8f9fa; position: absolute;\"></div>");

	var colors = ['#000000','#A0522D','#556B2F','#006400','#483D8B','#000080','#4B0082','#2F4F4F','#8B0000','#FF8C00','#808000','#008000','#008080','#0000FF','#708090','#696969','#FF0000','#F4A460','#9ACD32','#2E8B57','#48D1CC','#4169E1','#800080','#808080','#FF00FF','#FFA500','#FFFF00','#00FF00','#00FFFF','#00BFFF','#9932CC','#C0C0C0','#FFC0CB','#F5DEB3','#FFFACD','#98FB98','#AFEEEE','#ADD8E6','#DDA0DD','#FFFFFF'];
	var s = '';

	for(var i in colors)  s += "<div onClick=\"editor_applyColor('" + colors[i] + "')\" style='cursor: pointer; background: " + colors[i] + "; padding: 10px; margin: 1px; float: left;'></div>";
	$c.html(s);
	$c.mouseleave( function() { $(this).remove(); } );

	$c.appendTo('body').css({ top: pos.top + 18, left: pos.left - Math.round($c.width() / 2) });
}

function editor_quote() {
	/*var text = getSelectedText();
	if (text) editor_applyTag('\\n>' + text, '\\n');
	else*/ editor_applyTag('\\n>', '\\n');
}

function editor_applyColor(c) {
	editor_applyTag("<font color='" + c + "'>", '</font>');
	$('#editor-colors').remove();
	if(event) event.stopPropagation();
}

function editor_applyTag(s, e) {
	var $ta = $('.field-post-text');
	$ta.focus();

	editor_apply($ta[0], s, e);

	return false;
}

function thread_Key(event) {
	if((event.ctrlKey) && (event.keyCode == 0xA || event.keyCode == 0xD)) thread_sendPost();
}

function thread_closeForm(thread_id) {
	$('#thread-form').hide();
	return false;
}

function thread_Find(post_id, thread_id) {
	var $p = $('#post-' + post_id);
	var goto_post = function() {
		$p = $('#post-' + post_id);
		setTimeout(function() {$.scrollTo($p, {duration: 500, offset: { left : 0, top: -200 }, onAfter: function() {
			$p.addClass('mark');
			setTimeout(function() {$p.removeClass('mark');}, 3000);
		}})}, 100);
	};

	if(!$p.length) { //Поста нет на странице
		if(thread_id != undefined) {
			var $t = $('#thread-' + thread_id);
			if(!$t.length) { document.location = Static.server + '/thread/' + thread_id + '/#post-' + post_id; return false; }
		}

		$.getJSON(Static.base + '/thread.php', { thread: Static.thread.id, mode: 'ajax_findpost', id: post_id, session: Static.thread.session, style: Static.thread.style }, function(data) {
			if(!data.page) return false;
			var findpost = function() {if(data.parent_id) thread_expandTree(data.parent_id, goto_post); else goto_post();};
			if(Static.thread.page && Static.thread.page != data.page) thread_load(data.page, {}, findpost);
			else findpost();
		});
	} else goto_post();

	return true;
}

function thread_SelectHandle() {
	$('.post-text').mouseup(function(e) {
		if (localStorage.getItem('disableSelect')) return;
		var text = getSelectedText(), parent = $(e.currentTarget).parents('li');
		var post_id = parent.attr('id').split('-')[1];
		if (text != '') {
			$('#static-content').dialog({
				title: "Цитата",
				text: text + "<br><br><a href='#' onclick='localStorage.setItem(\"disableSelect\",1); $.dialog_Hide(); return false;'>Отключить навсегда</a>",
				buttons: {
					'quote' : ['js','Цитировать'],
					'copy' : ['js','Копировать'],
					'cancel' : ['cancel','Отмена']
				},

				onSuccess: function(f) {
					if (f == 'copy') navigator.clipboard.writeText(text);
					if (f == 'quote') thread_Quote(text, post_id);
				}
			});
		 }
	});
}
function getSelectedText() {
	if (window.getSelection) {
		return window.getSelection().toString();
	} else if (document.selection) {
		return document.selection.createRange().text;
	}
	return '';
}

function thread_Init2(params, onSuccess) {
	var defaults = { nav: true, replying: 0, style: 'lenta', total: 0, posts: 0, direct: 0 };
	Static.thread = $.extend(defaults, params);
	Static.thread.onSuccess = onSuccess;

	if(!params.tree) thread_Nav();

	setTimeout(function() {
		var fp = /#post-(\d+)/gi.exec(document.location.hash);
		if(fp != null && fp[1]) thread_Find(fp[1]);
	}, 300);

	var $form = $('#thread-form');

	if($form[0]) {
		$('body').click(function(event) {
			if($(event.toElement).is('a.highslide img, #imagelightbox-overlay, li.cur')) return true;
			thread_hidePost();
		});

		$form.click(function(event) {if($(event.toElement).is('a.highslide img')) return true;
			event.stopPropagation();
			player_deFocus();
		});

		editor_initUploader(false);
	}

	if(Static.thread.id && Static.user.id > 0) {
		Static.sock.bind('post', {action: 'subscribe_thread', thread_id: Static.thread.id}, thread_newPost);
		if ($('#thread-form').length) thread_SelectHandle();
	}

	if(!Static.thread.period_update) {
		var d = new Date(), offset = -d.getTimezoneOffset() * 60;
		Static.thread.period_update = setInterval(function() {
			var cur = Math.floor(Date.now() / 1000);
			$('.thread a.i').each(function() {
				var t = $(this);
				if(cur - t.data('date') < 86400) t.html(date_Relative(t.data('date') - 7 * 3600 + offset, undefined, cur));
			});
		}, 10000);
	}
}

function thread_newPost(data) {
	//console.log('post: ', data);
	if(data.error) thread_Error(data.error);
	else {
		//if($('#post-' + data.id).length) return false;
		if(typeof(data.is_online) === undefined) data.is_online = 1;

		var $post = thread_renderPost(data);

		if(Static.thread.sending && data.u_id == Static.user.id) {
			if(Static.thread.onSuccess) Static.thread.onSuccess();

			$('#field-post-text').val('');
			Static.thread.replying = 0;
			Static.thread.edit = 0;
			thread_hidePost();
			$('#field-loader').html('');
			Static.thread.sending = false;
			$('#post-preview').hide();
			$('#post-images').html('');
			Static.images = [];
			if(data.edit) {
				tagsProcess($("#post-" + data.id).hide().html($post).fadeIn(1000));
				return;
			}

			switch(Static.thread.style) {
				case 'lenta': default:
					$post.hide().prependTo('#thread-' + data.thread_id).fadeIn(1000);
					if(data.post_id) {
						var $info = $("<div class='box-ok'><div>Ответ отправлен.</div></div>");
						$('#post-' + data.post_id).after($info);
						setTimeout(function() { $info.fadeOut('slow'); }, 3000);
					}
					break;
				case 'posts':
					if(data.post_id) {
						$post.hide().insertAfter('#post-' + data.post_id).fadeIn(1000);
					} else {
						$post.hide().prependTo('#thread-' + data.thread_id).fadeIn(1000);
					}
				break;
			}
		} else if(!data.edit) $post.hide().prependTo('#thread-' + data.thread_id).fadeIn(1000);
		else $("#post-" + data.id).hide().html($post).fadeIn(1000);

		if(!data.edit) thread_UpdatePosts(data.server_date != undefined ? data.server_date : data.date);
		if(data.images) nbl.l("/resource/js/imagelightbox.min.js", lightbox_init);
	}
}

function thread_UpdatePosts(server_date) {
	server_date = parseInt(server_date);
	Static.thread.total++;
	Static.thread.posts++;
	$('#thread-total').html(Static.thread.posts);

	var i = 1;
	$('#thread-' + Static.thread.id + ' li').each(function() {
		//if (Static.thread.page == 1 && Static.thread.style == 'lenta') if (i > 10) { $(this).remove(); return; }
		if (!Static.thread.direct) {
			var a = $(this).find('a.i');
			if (server_date - a.data('date') < 86400) a.html(date_Relative(parseInt(a.data('date')), undefined, server_date));
		}
		i++;
	});

	if (Static.thread.page == 1) thread_Nav(1);
	else thread_onUpdate();
}

//--------------------------------------------------------------------------------------------------

function thread_renderPost(data) {
	var li_style = '';
	if (Static.thread.style != 'lenta' && data.level) {
		if (Static.thread.style == 'posts' && data.level > 5) data.level = 5;
		li_style = " style='margin-left: " + (data.level > 0 ? 10 + 15 * data.level : 0) + "px;'";
	}
	var str = "<li id='post-" + data.id + "'" + li_style + " class='t-" + data.thread_id + "'\">" + user_getAvatar(data) + "\
		<div class='info'>" + user_getLink(data) + "<small class='on' title='онлайн'>&nbsp; &#8226; &nbsp;" + "</small><small><a href='#post-" + data.id + "' class='i' data-date='" + data.date + "'>" + 'только что' + "</a></small>";
//		<div class='info'>" + user_getLink(data) + (data.is_online ? "<small class='on' title='онлайн'>&nbsp; &#8226; &nbsp;" : "<small title='оффлайн'>&nbsp; &#9675; &nbsp;") + "</small><small><a href='#post-" + data.id + "' class='i' data-date='" + data.date + "'>" + 'только что' + "</a>&nbsp;<img onClick='thread_Fave(" + data.thread_id + "," + data.id + ");' class='fave' title='В избранное' src='/resource/image/icon/star-small-empty.png'></small>";

	if (data.post_id) {
		str += " <a href='#post-" + data.post_id + "' onClick='return thread_Find(" + data.post_id + ", " + data.thread_id + ");' >" + (Static.thread.direct ? 'в ответ на &uarr;' : 'в ответ на &darr;') + "</a>&nbsp; ";
	}

	str += "</div><div class='rating'>";

	if (Static.thread.id) {
		str += "<span class='post-controls'>";
		if (!Static.thread.closed) {
			str += "<a href='#'  onClick='return thread_Reply(event, " + data.id + ")'><i class='i-reply' title='ответить'></i></a>";
			if (!Static.thread.can_delete && Static.user.id != data.u_id) {
				str += "<a href='#' id='report_" + data.id + "' onClick='return thread_Report(" + data.id + "," + data.thread_id + ")'><i class='i-report' title='жалоба'></i></a>";
			}
			if (Static.thread.can_delete || Static.user.id == data.u_id) {
				str += "<a href='#' id='edit_" + data.id + "' onClick='return thread_Edit(event, " + data.id + ")'><i class='i-feather' title='изменить'></i></a>";
				setTimeout(function() {$("edit_" + data.id).remove();}, 180000);
			}
			if (Static.thread.can_delete || Static.user.id == data.u_id) {
				str += "<a href='#' onClick='return thread_Delete(" + data.id + ")'><i class='i-trash' title='удалить'></i></a>";
				str += "<a href='#' onClick='return thread_Spoiler(" + data.id + ")'><i class='i-lock' title='в спойлер'></i></a>";
			}
		}
		str += "</span>";
	}

	var rating = data.rating_pos != undefined ? data.rating_pos + data.rating_neg : 0;
	rating = "<span onclick='post_getRating(this," + data.post_id + ")'" + (rating >= 0 ? ( rating > 0 ? " class='p'>+" + rating : ">" + rating) : " class='m'>&minus;" + Math.abs(rating)) + "</span>";

	if (Static.thread.can_vote) {
		str += "<a href='#' onClick='return thread_Vote(" + data.thread_id + "," + data.id + ",-1)'>&minus;</a> <span>" + rating + "</span> <a href='#' onClick='return thread_Vote(" + data.thread_id + "," + data.id + ",1)'>+</a>";
	} else {
		str += "<span class='pale' title='Свои комментарии оценивать нельзя.'>&minus; " + rating + "</span>";
	}

	if (data.images) {
		if (data.images.length == 1) {
			var image = data.images[0];
			data.text += "<br><br><a href='" + image.link + image.ext + "' class='highslide'><img src='" + image.link + image.ext + "' alt=''/></a>";
		} else if (data.images.length > 1) {
			data.text += "<ul class='post-images'>";
			$.each(data.images, function(idx, image) {
				data.text += "<li><a href='" + image.link + image.ext + "' class='highslide'><img src='" + image.link + "_48.jpg' alt=''/></a></li>";
			});
			data.text += "</ul>";
			data.text += "<small><a href='#' class='js' onClick='return thread_expandImages(" + data.id + ", this);'>раскрыть все картинки</a></small>";
		}
	}

	str += "</div></div><div class='post-text'>" + data.text + "</div></li>";

	return $(str);
}

//--------------------------------------------------------------------------------------------------

function thread_initTree(params, onSuccess) {
	var defaults = { nav: false, replying: 0 };
	Static.thread = $.extend(defaults, params);
	Static.thread.onSuccess = onSuccess;

	setTimeout(function() {
		var fp = /#post-(\d+)/gi.exec(document.location.hash);
		if(fp != null && fp[1]) thread_Find(fp[1]);
	}, 300);

	var $form = $('#thread-form');

	if($form[0]) {
		$('body').click(function() {
			thread_hidePost();
		});

		$form.click(function(event) {
			event.stopPropagation();
			player_deFocus();
		});

		editor_initUploader(false);
	}
}

function pasteHandler(e) {
	if (e.clipboardData) {
		var items = e.clipboardData.items;
		if (!items) return;
		for (var i = 0; i < items.length; i++) {
			if (items[i].type.indexOf("image") !== -1) {
				var file = items[i].getAsFile();
				//var extension = file.type.match(/\/([a-z0-9]+)/i)[1].toLowerCase();
				if (!editor_saveFile(file)) {
					$uploader.hide();
					return false;
				}
			}
		}
	}
}

function editor_initUploader(images) {
	if (typeof(window.FileReader) == 'undefined') return false;

	var $uploader = $('#image-uploader');
	if (!$uploader.length) return;

	Static.images = [];
	if (images) {
		Static.images = images;
		if (typeof editor_callbackImage != 'undefined') editor_callbackImage();
	}
	window.addEventListener("paste", pasteHandler);
	$(document).one('page.clean', function() {window.removeEventListener("paste", pasteHandler);});

	$uploader[0].ondragover = function() {
		$uploader.addClass('hover');
		return false;
	};

	$uploader[0].ondragleave = function() {
		$uploader.removeClass('hover');
		return false;
	};

	$uploader[0].ondrop = function(event) {
		event.preventDefault();
		$uploader.removeClass('hover');

		if (Static.images.length >= 5) {
			thread_Error('Нельзя загружать более 5 картинок за раз.');
			return false;
		}

		var url = event.dataTransfer.getData('url');
		if (url) {
			$.get(Static.base + '/thread.php',
				{
					thread: Static.thread.id,
					mode: 'ajax_upload_image',
					session: Static.thread.session,
					hash: Static.thread.hash,
					url: url
				},
				function(data) {
					editor_applyUploadedImage(data);
					editor_hideImageUploader(true);
				}
			);
		}

		var file_count = event.dataTransfer.files.length;
		if (file_count) $uploader.addClass('drop');
		if (file_count > 5) file_count = 5;

		for (var i = 0; i < file_count; i++) {
			var file = event.dataTransfer.files[i];
			if (!file) return false;

			if (!editor_saveFile(file)) {
				$uploader.hide();
				return false;
			}
		}
	}
}

function editor_saveFile(file) {
	if (file.size > 10485760) {
		thread_Error('Слишком большой файл.');
		$('#form-editor').show();
		return false;
	}

	var xhr = new XMLHttpRequest();
	xhr.upload.addEventListener('progress', function(event) {
		//$uploader.find('div').html(parseInt(event.loaded / event.total * 100) + '%');
	}, false);

	xhr.onreadystatechange = function(event) {
		if (event.target.readyState == 4) {
			//console.log(event.target.responseText);
			if (event.target.status == 200) {
				editor_applyUploadedImage(event.target.responseText);
			} else {
				thread_Error('Произошла ошибка!');
			}
			editor_hideImageUploader(true);
		}
	};

	xhr.open('POST', Static.base + '/thread.php?thread=' + Static.thread.id + '&mode=ajax_upload_image&session=' + Static.thread.session + '&hash=' + Static.thread.hash);
	xhr.setRequestHeader('X-FILE-NAME', encodeURIComponent(file.name));
	var fd = new FormData;
	fd.append("file", file, file.name);
	xhr.send(fd);
	return true;
}

function editor_applyUploadedImage(data) {
	try {
		data = JSON.parse(data);
		if(data.success) {
			Static.images.push(data.id);
			var html = $("<li id='i-" + data.id + "'><a href='https://image.krasview.ru/thread/" + data.user_id + '/' + data.hash + ".jpg' class='highslide'><img src='https://image.krasview.ru/thread/" + data.user_id + '/' + data.hash + "_48.jpg'/></a><div><a href='#' onClick=\"return editor_deleteUploadedImage('" + data.id + "');\"><i class='i-cancel'></i></a></li>");
			$('#post-images').append(html);
		} else {
			thread_Error(data.error);
		}
	} catch (e) {console.log(e); thread_Error('Произошла ошибка!'); }
}

function editor_showImageUploader() {
	var uploader = $('#image-uploader');
	uploader.find('div.zone').hide();
	$('#form-editor').hide();
	uploader.show();

	uploader.find('div.form').css('height', 210).html("<iframe id='iframe-image-form' name='iframe-image-form' src='javascript:false' style='width: 1px; height: 1px; display: none;' frameborder='0'>\
	</iframe>\
	<form id='image-insert-form' onSubmit=\"editor_applyImage($('#image-link').val()); editor_hideImageUploader(true); return false;\">Укажите ссылку на изображение:<br><input type='text' id='image-link'></form><br><br>\
	<form id='image-upload-form' action='" + Static.base + "/thread.php?thread=" + (Static.thread && Static.thread.id ? Static.thread.id : "0") + "&mode=ajax_upload_image' method='post' enctype='multipart/form-data' target='iframe-image-form'>\
	Или выберите файл:<br><input type='file' name='file' onChange=\"$('#image-upload-form').submit();\"></form><br><br>\
	<small>Или просто перетащите файл мышкой в это окно.</small>\n\
	<div class='buttons'><a href='#' onClick=\"return editor_hideImageUploader(true);\">&larr; Назад</a> &nbsp;<input type='button' value='Вставить картинку' onClick=\"$('#image-insert-form').submit();\"></div>").show();

	$('#image-link').focus();

	$('#iframe-image-form').on('load', function() {
		var doc = this.contentDocument ? this.contentDocument : window.frames[this.id].document;
		if(doc.body) {
			var response = doc.body.innerHTML;

			response = /{(.*?)}/.exec(response);
			if(response && response[0]) {
				response = response[0];

				editor_applyUploadedImage(response);
				editor_hideImageUploader(true);
				if(typeof editor_callbackImage != 'undefined') editor_callbackImage(response);
			}
		}
	});

	return false;
}

function editor_hideImageUploader(focus) {
	$('#image-uploader').removeClass('drop').hide();
	$('#form-editor').show();
	if(focus) $('#field-post-text').focus();
	return false;
}

function editor_deleteUploadedImage(id) {
	var index = $.inArray(id, Static.images);
	if(index > -1) Static.images.splice(index, 1);
	$('#i-' + id).remove();
	return false;
}

function thread_expandImages(post_id, link) {
	$('#post-' + post_id + ' ul.post-images li').each(function() {
		var a = $(this).find('a');
		a.replaceWith("<img src='" + a.prop('href') +"'/>");
		$(this).addClass('m');
	});
	$(link).remove();
	return false;
}

function thread_expandTree(post_id, callback) {
	var subtree = $('.more-' + post_id);
	subtree.html("<img src='" + Static.base + "/resource/image/icon/ajax.gif'>");

	$.get(Static.base + '/thread.php', {'mode': 'ajax_expand_tree', 'post_id': post_id}, function(data) {
		$('#post-' + post_id).after(data);
		$.scrollTo($('#post-' + post_id), { duration: 500, offset: { left : 0, top: -20 } });
		subtree.remove();
		thread_onUpdate();
		if(typeof callback != 'undefined') callback();
	});

	return false;
}

function thread_Update(params) {
	Static.thread = $.extend(Static.thread, params);
	thread_onUpdate();
}

function thread_load(page, params, callback) {
	var limit = 10;
	var pages = Math.ceil(Static.thread.posts / limit);
	if (page > pages) return false;

	var post_id_first = 0;
	if (Static.thread.page + 1 == page) {
		post_id_first = 99999999;
		$('#thread-' + Static.thread.id + ' li.ready').each(function () {
			var attr = $(this).attr('id');
			if (!attr || attr == 'thread-load') return;
			var attrs = attr.split('-'), id = parseInt(attrs[1]);
			if (id < post_id_first) post_id_first = id;
		});
		if (post_id_first == 99999999) post_id_first = 0;
	}

	var defaults = {
		direct: ($('#thread-'+Static.thread.id).hasClass('direct') ? 1 : 0),
		style: Static.thread.style,
		ajax: true,
		append: false,
		session: Static.thread.session
	};

	$('#thread-load').removeClass('load').addClass('loaded').html("<img src='" + Static.base + "/resource/image/icon/ajax.gif'>");
	if (Static.thread.posts > 10) $('#thread-nav').html("<img src='" + Static.base + "/resource/image/icon/ajax.gif'>");

	Static.thread.page = page;
	params = $.extend(defaults, Static.thread, params, { page: page });
	params.post_id_first = post_id_first;

	$.get(Static.base + '/thread.php', params, function(data) {
		$('#thread-load').attr('id','').html('Страница ' + page);
		if (params.append) $('#thread-'+Static.thread.id).append(data); else $('#thread-'+Static.thread.id).html(data);
		$('#thread-nav').html('');
		thread_Nav(1);
		if (typeof callback == 'function') callback();
	});

	return false;
}

function thread_onUpdate() {
	$('.thread li:not(.ready)').on('mouseover', function() {$(this).find('.post-controls').show();}).on('mouseleave', function() {$(this).find('.post-controls').hide();}).addClass('ready');

	$('.post-text:not(.ready)').each(function(i, val) {
		tagsProcess($(val).addClass('ready'));
	});
}
function tagsProcess(el) {
	var text = el.html();
	text = text.replace(/:([a-z-]+[0-9]?):(?!([^<]+)?>)/gi, "<img src='/content/emoji/$1.png'>");
	text = text.replace(/(^|[ ,;.?!>])#([а-яёa-z0-9-]{1,30})(?!([^<]+)?>)/gi, "$1<a href='/thread/tag/$2'>#$2</a>");
	el.html(text);
	el.find('.video-block').append('<span><i class="i-videocam"></i></span>');
}

function thread_Nav(append) {
	thread_onUpdate();
	if (!Static.thread.nav) return;
	if($('#thread-load').length) return;

	if(!$('#thread-nav').length) $('#thread-' + Static.thread.id).before("<div id='thread-nav' class='pager-tiny'></div>");
	if($('#thread-form').length) $('#thread-nav').css('margin-top','10px');

	var res = '';
	var limit = 10;
	var range = 2

	if (Static.thread.posts <= limit) return;

	var pages = Math.ceil(Static.thread.posts / limit);
	//if(pages > 100) pages = 100;

	if (Static.thread.page > 1)
		res += "<a href='#' onClick='return thread_load(Static.thread.page - 1);'>&#8592;</a><a href='#' onClick='return thread_load(1);'>1</a>" + (Static.thread.page > range+2 ? "<em>...</em>" : '');

	for (var i = 1; i <= pages; i++) {
		if (i == Static.thread.page) {
			res += "<span>" + i + "</span>";
		} else {
			if ((i >= Static.thread.page-range && i < Static.thread.page) || (i <= Static.thread.page+range && i > Static.thread.page))
			if (i != 1 && i != pages) res += "<a href='#' onClick='return thread_load(" + i + ");'>" + i + "</a>";
		}
	}

	if (Static.thread.page < pages) {
		if (Static.thread.page < pages - range) res += "<em>...</em>";
		res += "<a href='#' onClick='return thread_load(" + pages + ");'>" + pages + "</a><a href='#' onClick='return thread_load(Static.thread.page + 1);'>&#8594;</a>";
		//res += "<span>" + pages + "</span><a href='#' onClick='return thread_load(Static.thread.page + 1);'>&#8594;</a>";
	}

	$('#thread-nav').html(res);
	if (typeof append == 'undefined') {
		var nav_by_key = function(e) {
			if (Static.thread.replying || Static.thread.edit || Static.thread.sending || $('#thread-form.opened').length) return;
			e = e || window.event;
			var keyCode = e.keyCode || e.which;
			if (e.ctrlKey && keyCode == 37 && Static.thread.page > 1) thread_load(Static.thread.page - 1);
			if (e.ctrlKey && keyCode == 39 && Static.thread.page < pages) thread_load(Static.thread.page + 1);
		}
		document.addEventListener("keydown", nav_by_key);
		$(document).one('page.clean', function() {document.removeEventListener("keydown", nav_by_key);});
	}

	if (Static.thread.page < pages && !$('.all').length)
		$('#thread-' + Static.thread.id).append("<li id='thread-load' class='load'><a class='load' href='#' onClick='return thread_load(Static.thread.page + 1, { append: true });'>" + (Static.thread.direct ? 'Далее' : 'Ранее') + "</a></li>");
}

function thread_reorder(all) {
	var direct = all ? 0 : ($('#thread-' + Static.thread.id).hasClass('direct') ? 1 : 0);
	if (all) $('#title-main').html('Моя лента');

	$('.thread-reorder').html(direct ? 'с начала' : 'с конца');

	if (!all) {
		Static.thread.direct = 1 - direct;
		$('#thread-' + Static.thread.id).toggleClass('direct');
	}

	thread_load(1);

	return false;
}

function thread_Unfollow(id) {
	if (confirm("Вы уверены, что хотите отписаться?")) {
		$.getJSON(Static.base + '/thread.php', { thread: id, mode: 'ajax_unfollow' }, function(data) {
			if (!data.success) return false;
			$('#thread-counter').html(str_Numeral(data.count,'комментари|й|я|ев'));
			thread_load(1);
			if ($('#thread_unfollow').length) $('#thread_unfollow').hide();
			if ($('li.t-' + id).length) $('li.t-' + id).fadeOut('fast', function() { $(this).remove(); });
		});
	}
	return false;
}

function thread_sendPost() {
	var text = $('#field-post-text').val();
	text = utf8_to_cp1251(text);
	if (text == '') {
		thread_Error('Введите текст сообщения!');
		$('#field-post-text').focus();
		return false;
	}

	if (Static.thread.sending) return;
	Static.thread.sending = true;

	$('#field-loader').html("<img src='" + Static.base + "/resource/image/icon/ajax.gif'>");
	if (Static.sock) {
		var Post = {text: text};
		if (Static.images) Post['images'] = Static.images;
		if (Static.thread.replying) Post['reply_to'] = Static.thread.replying;
		if (Static.thread.edit) Post['edit'] = Static.thread.edit;
		Static.sock.send({ action: 'post', post: Post });
		return false;
	}
	/*$.post(Static.base + '/thread.php?thread=' + Static.thread.id + '&mode=ajax_post&session=' + Static.thread.session, {reply_to: Static.thread.replying, direct: Static.thread.style == 'lenta' ? 0 : 1, style: Static.thread.style, text: text, hash: Static.thread.hash, style: Static.thread.style, images: Static.images}, function(data) {
		if(data.length > 100) {
			if(Static.thread.edit) $('#post-' + Static.thread.edit).html(data);
			switch(Static.thread.style) {
				case 'lenta': default:
					$(data).hide().prependTo('#thread-' + Static.thread.id).fadeIn('slow');
					if(Static.thread.replying) {
						var $info = $("<div class='box-ok'><div>Ответ отправлен.</div></div>");
						$('#post-' + Static.thread.replying).after($info);
						setTimeout(function() { $info.fadeOut('slow'); }, 3000);
					}
					break;

				case 'posts':
					if(Static.thread.replying) {
						$(data).hide().insertAfter('#post-' + Static.thread.replying).fadeIn('slow');
					} else {
						$(data).hide().prependTo('#thread-' + Static.thread.id).fadeIn('slow');
					}
					break;
			}

			thread_UpdatePosts($(data).find('a.i').data('date'));

			$('#field-post-text').val('');

			if(Static.thread.onSuccess) Static.thread.onSuccess();
		} else {
			thread_Error(data);
		}
		Static.thread.replying = 0;
		Static.thread.edit = 0;
		thread_hidePost();
		$('#field-loader').html('');
		Static.thread.sending = false;
		$('#post-preview').hide();
		$('#post-images').html('');
		Static.images = [];
	});*/

	return false;
}

function thread_Error(error) {
	$('#thread-form-error').html(error).slideDown('fast');
	setTimeout(function() { $('#thread-form-error').slideUp(); }, 4000);
}

function thread_Vote(id, post_id, delta) {
	var hash = Static.thread.hash == undefined ? 0 : Static.thread.hash;

	$.getJSON(Static.base + '/thread.php', { thread: id, mode: 'ajax_vote', post: post_id, delta: delta, hash: hash, session: Static.thread.session }, function(data){
		if(data.error == 'voted') { dialog_info("Вы уже оценивали этот комментарий!"); return false; }
		if(data.error == 'vote_interval') { dialog_info('Оценивать комментарии одного и того же человека можно не чаще, чем раз в 30 секунд.'); return false; }
		if(data.error) { dialog_info(data.error, 'Ошибка'); return false; }
		if(!data.success) return false;

		var $rating = $('#post-' + data.id + ' .rating span[class!=post-controls], #post-top-' + data.id + ' .rating span[class!=post-controls]');
		rating_set($rating, data.rating);

		Static.sock.send({action: 'vote', post_id: post_id, delta: delta, type: Static.thread.type});
	});

	return false;
}

function thread_Fave(id, post_id) {
	$('#post-'+ post_id + ' .fave').prop('src', Static.base + '/resource/image/icon/ajax.gif');
	$.getJSON(Static.base + '/thread.php', { thread: id, mode: 'ajax_fave', post: post_id, session: Static.thread.session }, function(data){
		if(!data.success)  return false;
		if(data.faved) {
			$('#post-' + data.id + ' .fave').prop('src', Static.base + '/resource/image/icon/star-small.png');
		} else {
			$('#post-' + data.id + ' .fave').prop('src', Static.base + '/resource/image/icon/star-small-empty.png');
		}
	});

	return false;
}

function thread_Delete(post_id, thread_id, hash) {
	if (!confirm("Вы уверены?")) return false;
	if (typeof thread_id == 'undefined') {
		thread_id = Static.thread.id;
		hash = Static.thread.hash;
	}

	$.getJSON(Static.base + '/thread.php?thread=' + thread_id, { mode: 'ajax_delete', post: post_id, hash: hash }, function(data) {
		var html;
		if (data.success) {
			html = "<div class='rating'><a href='#' onClick=\"return thread_Restore(" + post_id + ", " + thread_id + ", '" + hash + "');\">Восстановить</a></div>";
			if (data.reasons) {
				var form = "";
				for (var idx in data.reasons) {
					form += "<label><input name='reason' type='radio' value='" + idx + "'> " + data.reasons[idx] + "</label>";
				}
				html += "<div class='reason'>Причина удаления:<br><form>" + form + "</form></div>";
			}
		} else html = data.error;

		$('#post-' + post_id).data('content', $('#post-' + post_id).html()).html(html);

		$('#thread-total').html(parseInt($('#thread-total').html())-1);
		$('#post-' + post_id + ' input[name=reason]').on('click', function() {
			var reason = $('#post-' + post_id + ' input[name=reason]:checked').val();
			$.getJSON(Static.base + '/thread.php?thread=' + thread_id, { mode: 'ajax_delete_reason', post: post_id, hash: hash, reason_id: reason }, function(data) {
				if (data.success) {
					$('#post-' + post_id + ' .reason').html('Спасибо!');
				}
			});
		});
	});

	return false;
}

function thread_Spoiler(post_id, thread_id, hash) {
	if (!confirm("Вы уверены?")) return false;
	if (typeof thread_id == 'undefined') {
		thread_id = Static.thread.id;
		hash = Static.thread.hash;
	}
	$.getJSON(Static.base + '/thread.php?thread=' + thread_id, { mode: 'ajax_delete', post: post_id, hash: hash, action: 1 }, function(data) {
		if (data.success) {
			var text = $('#post-' + post_id + ' .post-text').html();
			$('#post-' + post_id + ' .post-text').html("<span class='spoiler'>" + text + "</span>");
		} else if (data.error) dialog_info(data.error);
	});

	return false;
}

function thread_Report(post_id, thread_id) {
	$('#report_' + post_id).hide();
	$.getJSON(Static.base + '/thread.php?thread=' + thread_id, { mode: 'ajax_report_options', post: post_id }, function(data) {
		var html;
		if (data.error) {
			dialog_info(data.error, 'Ошибка');
			return;
		} else if (data.reasons) {
			var form = "";
			for (var idx in data.reasons) {
				form += "<label><input name='reason' type='radio' value='" + idx + "'> " + data.reasons[idx] + "</label>";
			}
			html = "<div class='reason'>Что не так:<br><form>" + form + "</form></div>";
		}

		$('#post-' + post_id).data('content', $('#post-' + post_id).html()).html(html);

		$('#post-' + post_id + ' input[name=reason]').on('click', function() {
			var reason = $('#post-' + post_id + ' input[name=reason]:checked').val();
			$.getJSON(Static.base + '/thread.php?thread=' + thread_id, { mode: 'ajax_report', post: post_id, reason_id: reason }, function(data) {
				if (data.success) {
					$('#post-' + post_id).html($('#post-' + post_id).data('content'));
					dialog_info('Жалоба отправлена, спасибо.', 'Уведомление');
				}
			});
		});
	});
	return false;
}

function thread_Violate_Res(post_id, thread_id, id, res) {
	$.getJSON(Static.base + '/thread.php?thread=' + thread_id, { mode: 'ajax_violate_res', post: post_id, res: res, id: id }, function(data) {
		if (!data.success) return false;

		$('#thread-total').html(parseInt($('#thread-total').html())-1);
		$('#post-' + post_id).remove();

		console.log(123);
	});
}

function thread_Restore(post_id, thread_id, hash) {
	$.getJSON(Static.base + '/thread.php?thread=' + thread_id, { mode: 'ajax_restore', post: post_id, hash: hash }, function(data) {
		if (!data.success) return false;

		$('#post-' + post_id).html($('#post-' + post_id).data('content'));

		$('#thread-total').html(parseInt($('#thread-total').html()) + 1);
	});

	return false;
}

function rating_set(el, rating) {
		el.removeClass('m p gray');

		if(rating >= 0) {
			if (rating == 0) el.addClass('gray').html('0'); else el.addClass('p').html('+' + rating);
		} else {
			el.addClass('m').html('&minus;' + Math.abs(rating));
		}
}

function rating_Vote(id, delta) {
	$.getJSON(Static.base + '/thread', { mode: 'ajax_rating_vote', rating: id, delta: delta }, function(data) {
		if(data.error == 'voted') { dialog_info('Вы уже оценивали.'); return false; }
		if(data.error == 'vote_interval') { dialog_info('Оценивать видео одного и того же пользователя можно не чаще, чем раз в 30 секунд.'); return false; }
		if(data.error == 'video_not_watched') { dialog_info('Видео можно оценивать только после того, как вы его посмотрели. Хотя бы частично.'); return false; }
		if(!data.success) { return false; }

		rating_set($('#object-rating-' + id + ' span'), data.rating);

		var $vals = $('#object-rating-' + id).find('.rating-val');
		$($vals[0]).html(data.rating_neg);
		$($vals[1]).html(data.rating_pos);

		if(delta > 0) {
			$('#object-rating-' + id + ' .rating-up').attr('src', '/resource/image/icon/arrow-green-up.png');
		} else {
			$('#object-rating-' + id + ' .rating-down').attr('src', '/resource/image/icon/arrow-red-down.png');
		}

		$('#object-rating-' + id + ' .object-rating-ruler').css('background-position', data.shift + ' 0');
	});

	return false;
}

function thread_renderNotify(data) {
	var m = "<div class='clear'><h1>Ответ на <a href='#post-" + data.post_id + "' onClick='return thread_Find(" + data.post_id + ", " + data.thread_id + ");' >ваше сообщение</a></h1></div><br><div class='clear'>" + user_getAvatar(data, 48) + "<div class='text'>" + user_getLink(data) + "<br>" + data.text + "</div></div></div>";
	renderNotify(data.u_login, m, '/thread/' + data.thread_id + '/#post-' + data.id);
}

function vote_renderNotify(data) {
	var m = "<div class='clear'><h1><a href='#post-" + data.post_id + "' onClick='return thread_Find(" + data.post_id + ", " + data.thread_id + ");' >Ваше сообщение</a> оценили: <span class='" + (data.delta > 0 ? 'p' : 'm') + "'>" + (data.delta > 0 ? '+' : '') + data.delta + "</span></h1></div><br><div class='clear'>" + user_getAvatar(data, 48) + "<div class='text'>" + user_getLink(data) + "</div></div></div>";
	renderNotify(data.u_login, m, '/thread/' + data.thread_id + '/#post-' + data.id);
}

function post_topDel(post_id) {
	$.getJSON(Static.base + '/thread.php?thread=' + Static.thread.id, {mode: 'ajax_post_top_del', id: post_id}, function(data) {
		if(!data.success) return false;

		$('#post-top-' + post_id).remove();
	});

	return false;
}

function post_getRating(el, id) {
	el = $(el);
	el.html("<img src='" + Static.base + "/resource/image/icon/ajax.gif'>");
	$.getJSON(Static.base + '/thread.php?thread=' + Static.thread.id, { mode: 'ajax_get_rating', post: id }, function(data) {
		var text = '<table class="ilist">';
		for (var i in data.votes) {
			var vote = data.votes[i];
			var menu = vote.del ? " <a href='#' onclick='return post_delVote(" + id + ")'><i class='i-cancel'></i></a>" : "";
			text += '<tr><td>' + user_getAvatar(vote, 24) + '<div style="padding-top:6px;">' + user_getLink(vote) + '</div></div></td><td><span class="' + (vote.delta == 1 ? 'p' : 'm') + '">' + (vote.delta == 1 ? '+' : '-') + '1</span></td><td>' + vote.date + menu + '</td></tr>';
		}
		text += '</table>';
		rating_set(el, data.rating);

		if (data.votes.length) dialog_info(text, 'Оценки комментария');
	});
}

function post_delVote(id) {
	$.getJSON(Static.base + '/thread.php?thread=' + Static.thread.id, { mode: 'ajax_del_vote', post: id }, function(data) {
		if (data.success) {
			dialog_info('Голос удалён', 'Уведомление');
			rating_set($('#post-' + id + ' .rating-value'), data.rating);
		} else dialog_info('Голос не удалён', 'Уведомление');
	});
	return false;
}

function thread_search() {
	var el = $('#query'),  container = "thread-" + Static.thread.id;
	if($(el).val().length < 2 && Static.thread.total_preserve) {
/*		Static.thread.mode = Static.thread.mode_preserve;
		Static.thread.page = Static.thread.page_preserve;
		$('#thread-load').attr('id','').html('Страница ' + Static.thread.page);
		thread_Nav(Static.thread.page);*/

		$('#' + container).show();
		$('#thread-form-top').show();
		$('#search-results').hide();
		$('#thread-nav').show();
		Static.thread.total = Static.thread.total_preserve;
		Static.thread.total_preserve = 0;
		$('#thread-total').html(Static.thread.total);
	} else if ($(el).val().length >= 2) {
		$('#search-results').show().html("<img src='" + Static.base + "/resource/image/icon/ajax.gif'>");
		if (!Static.thread.total_preserve) Static.thread.total_preserve = Static.thread.total;

		$.post(Static.base + '/thread.php?mode=ajax_search&thread=' + Static.thread.id, {query: $(el).val()},
			function(data) {
				/*Static.thread.page_preserve = Static.thread.page;
				Static.thread.page = 1;
				Static.thread.mode_preserve = Static.thread.mode;
				Static.thread.mode = 'ajax_search';
				$('#thread-load').attr('id','').html('Страница 1');
				$('#thread-nav').html('');
				thread_Nav(1);*/

				$('#search-results').html(data).show();
				$('#' + container).hide();
				$('#thread-form-top').hide();
				$('#thread-nav').hide();
		});
		return !1;
	}

	return false;
}


function atWho_init() {nbl.l('/resource/js/jquery.atwho.min.js', atWho);}
function atWho() {
	var input = $('.field-post-text');
	if(input.data('atWho') == 1) return;
	var emojis = [
		"angry","minishock","please","boring","surprised","ghost","speechless","annoyed","smile","silly","not-guilty","blanco","ill","zzz",
		"total-shock","alien-2","kissy","goatse","why-thank-you","zip-it","sad","devil-laugh","in-love","female","crazy","devil","cry","tease",
		"laugh","wink","angel","fools","hay","meow","blush","alien-1","xd","oh","cool","mario","male","geek","james","nomnomnom","not-one-care"
	];
	// https://github.com/ichord/At.js/wiki/How-to-use-remoteFilter
	input.atwho({
		at: "@",
		insertTpl: '@${login}',
		displayTpl: "<li>${link}</li>",
		searchKey: 'login',
		callbacks: {remoteFilter: function(q, callback) {
			if("" == q) return;
			$.getJSON("/ajax/threadUsers", {q: q}, function(data) {callback(data);})
		}}
	}).atwho({
		at: ":",
		insertTpl: ':${key}:',
		displayTpl: "<li>${name} <img src='/content/emoji/${key}.png'></li>",
		searchkey: 'key',
		data: null,
		callbacks: {remoteFilter: function(q, callback) {
			if("" == q) return;
			var data = emojis.filter(function(item) {return item.indexOf(q) == 0;});
			var emojis2 = $.map(data, function(value, i) {return {key: value, name: value}});
			callback(emojis2);
		}}
	}).atwho({
		at: "#",
		data: null,
		callbacks: {remoteFilter: function(q, callback) {
			if("" == q) return;
			$.getJSON("/ajax/threadTags", {q: q}, function(data) {callback(data);})
		}}
	}).data('atWho', 1);
}